export default __webpack_public_path__ + "static/media/wrong.ed797694.mp3";